export const SUPPORTED_COUNTRIES = [
  {
    code: 'BR',
    name: 'Brasil',
    nameEn: 'Brazil',
    nameEs: 'Brasil',
    flag: '🇧🇷',
    documentLabel: 'CPF ou CNPJ',
    documentLabelEn: 'CPF or CNPJ',
    documentLabelEs: 'CPF o CNPJ',
    documentRequired: true,
    documentPlaceholder: '000.000.000-00 ou 00.000.000/0000-00',
    minLength: 11,
    maxLength: 14
  },
  {
    code: 'US',
    name: 'Estados Unidos',
    nameEn: 'United States',
    nameEs: 'Estados Unidos',
    flag: '🇺🇸',
    documentLabel: 'EIN/SSN',
    documentLabelEn: 'EIN/SSN',
    documentLabelEs: 'EIN/SSN',
    documentRequired: false,
    documentPlaceholder: '00-0000000 or 000-00-0000',
    minLength: 9,
    maxLength: 11
  },
  {
    code: 'MX',
    name: 'México',
    nameEn: 'Mexico',
    nameEs: 'México',
    flag: '🇲🇽',
    documentLabel: 'RFC',
    documentLabelEn: 'RFC',
    documentLabelEs: 'RFC',
    documentRequired: false,
    documentPlaceholder: 'ABCD1234567XX',
    minLength: 12,
    maxLength: 13
  },
  {
    code: 'AR',
    name: 'Argentina',
    nameEn: 'Argentina',
    nameEs: 'Argentina',
    flag: '🇦🇷',
    documentLabel: 'CUIT/CUIL',
    documentLabelEn: 'CUIT/CUIL',
    documentLabelEs: 'CUIT/CUIL',
    documentRequired: false,
    documentPlaceholder: '00-00000000-0',
    minLength: 11,
    maxLength: 11
  },
  {
    code: 'CO',
    name: 'Colômbia',
    nameEn: 'Colombia',
    nameEs: 'Colombia',
    flag: '🇨🇴',
    documentLabel: 'NIT/RUT',
    documentLabelEn: 'NIT/RUT',
    documentLabelEs: 'NIT/RUT',
    documentRequired: false,
    documentPlaceholder: '000000000-0',
    minLength: 9,
    maxLength: 10
  },
  {
    code: 'CL',
    name: 'Chile',
    nameEn: 'Chile',
    nameEs: 'Chile',
    flag: '🇨🇱',
    documentLabel: 'RUT',
    documentLabelEn: 'RUT',
    documentLabelEs: 'RUT',
    documentRequired: false,
    documentPlaceholder: '00.000.000-0',
    minLength: 8,
    maxLength: 9
  },
  {
    code: 'PE',
    name: 'Peru',
    nameEn: 'Peru',
    nameEs: 'Perú',
    flag: '🇵🇪',
    documentLabel: 'RUC',
    documentLabelEn: 'RUC',
    documentLabelEs: 'RUC',
    documentRequired: false,
    documentPlaceholder: '00000000000',
    minLength: 11,
    maxLength: 11
  },
  {
    code: 'UY',
    name: 'Uruguai',
    nameEn: 'Uruguay',
    nameEs: 'Uruguay',
    flag: '🇺🇾',
    documentLabel: 'RUT',
    documentLabelEn: 'RUT',
    documentLabelEs: 'RUT',
    documentRequired: false,
    documentPlaceholder: '000000000000',
    minLength: 12,
    maxLength: 12
  },
  {
    code: 'PY',
    name: 'Paraguai',
    nameEn: 'Paraguay',
    nameEs: 'Paraguay',
    flag: '🇵🇾',
    documentLabel: 'RUC',
    documentLabelEn: 'RUC',
    documentLabelEs: 'RUC',
    documentRequired: false,
    documentPlaceholder: '00000000',
    minLength: 6,
    maxLength: 8
  },
  {
    code: 'EC',
    name: 'Equador',
    nameEn: 'Ecuador',
    nameEs: 'Ecuador',
    flag: '🇪🇨',
    documentLabel: 'RUC',
    documentLabelEn: 'RUC',
    documentLabelEs: 'RUC',
    documentRequired: false,
    documentPlaceholder: '0000000000001',
    minLength: 13,
    maxLength: 13
  },
  {
    code: 'BO',
    name: 'Bolívia',
    nameEn: 'Bolivia',
    nameEs: 'Bolivia',
    flag: '🇧🇴',
    documentLabel: 'NIT',
    documentLabelEn: 'NIT',
    documentLabelEs: 'NIT',
    documentRequired: false,
    documentPlaceholder: '0000000000',
    minLength: 7,
    maxLength: 10
  },
  {
    code: 'VE',
    name: 'Venezuela',
    nameEn: 'Venezuela',
    nameEs: 'Venezuela',
    flag: '🇻🇪',
    documentLabel: 'RIF/NIT',
    documentLabelEn: 'RIF/NIT',
    documentLabelEs: 'RIF/NIT',
    documentRequired: false,
    documentPlaceholder: 'J-000000000',
    minLength: 9,
    maxLength: 10
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    nameEn: 'Costa Rica',
    nameEs: 'Costa Rica',
    flag: '🇨🇷',
    documentLabel: 'Cédula Jurídica',
    documentLabelEn: 'Legal ID',
    documentLabelEs: 'Cédula Jurídica',
    documentRequired: false,
    documentPlaceholder: '0-000-000000',
    minLength: 9,
    maxLength: 12
  },
  {
    code: 'PA',
    name: 'Panamá',
    nameEn: 'Panama',
    nameEs: 'Panamá',
    flag: '🇵🇦',
    documentLabel: 'RUC',
    documentLabelEn: 'RUC',
    documentLabelEs: 'RUC',
    documentRequired: false,
    documentPlaceholder: '00000000-00',
    minLength: 8,
    maxLength: 10
  },
  {
    code: 'GT',
    name: 'Guatemala',
    nameEn: 'Guatemala',
    nameEs: 'Guatemala',
    flag: '🇬🇹',
    documentLabel: 'NIT',
    documentLabelEn: 'NIT',
    documentLabelEs: 'NIT',
    documentRequired: false,
    documentPlaceholder: '0000000-0',
    minLength: 7,
    maxLength: 8
  },
  {
    code: 'SV',
    name: 'El Salvador',
    nameEn: 'El Salvador',
    nameEs: 'El Salvador',
    flag: '🇸🇻',
    documentLabel: 'NIT',
    documentLabelEn: 'NIT',
    documentLabelEs: 'NIT',
    documentRequired: false,
    documentPlaceholder: '0000-000000-000-0',
    minLength: 14,
    maxLength: 14
  },
  {
    code: 'HN',
    name: 'Honduras',
    nameEn: 'Honduras',
    nameEs: 'Honduras',
    flag: '🇭🇳',
    documentLabel: 'RTN',
    documentLabelEn: 'RTN',
    documentLabelEs: 'RTN',
    documentRequired: false,
    documentPlaceholder: '00000000000000',
    minLength: 14,
    maxLength: 14
  },
  {
    code: 'NI',
    name: 'Nicarágua',
    nameEn: 'Nicaragua',
    nameEs: 'Nicaragua',
    flag: '🇳🇮',
    documentLabel: 'RUC',
    documentLabelEn: 'RUC',
    documentLabelEs: 'RUC',
    documentRequired: false,
    documentPlaceholder: '00000000000000',
    minLength: 14,
    maxLength: 14
  },
  {
    code: 'DO',
    name: 'República Dominicana',
    nameEn: 'Dominican Republic',
    nameEs: 'República Dominicana',
    flag: '🇩🇴',
    documentLabel: 'RNC/Cédula',
    documentLabelEn: 'RNC/ID',
    documentLabelEs: 'RNC/Cédula',
    documentRequired: false,
    documentPlaceholder: '000-0000000-0',
    minLength: 9,
    maxLength: 11
  },
];

export const getCountryByCode = (code) => {
  return SUPPORTED_COUNTRIES.find(c => c.code === code) || SUPPORTED_COUNTRIES[0];
};

export const getCountryName = (code, language = 'pt') => {
  const country = getCountryByCode(code);
  if (language === 'en') return country.nameEn;
  if (language === 'es') return country.nameEs;
  return country.name;
};

export const getDocumentLabel = (code, language = 'pt') => {
  const country = getCountryByCode(code);
  if (language === 'en') return country.documentLabelEn;
  if (language === 'es') return country.documentLabelEs;
  return country.documentLabel;
};
